import {ReactNode} from 'react';
import {ChannelType, UserStatus} from '@time-webkit/all/types/general';

export enum SuggestionType {
    User = 'user',
    Bot = 'bot',
    Channel = 'channel',
}

export type UserSuggestionProps = {
    type: SuggestionType.User;
    className?: string;
    avatar: string;
    status?: UserStatus;
    fullName: string;
    username: string;
    badge?: ReactNode;
    userPosition: string;
    userDepartment?: string;
    deactivated?: boolean;
    unreadCount?: number;
    customStatus?: ReactNode;
    onClick?: () => void;
};

export type BotSuggestionProps = {
    type: SuggestionType.Bot;
    className?: string;
    avatar: string;
    name: string;
    login: string;
    deactivated?: boolean;
    onClick?: () => void;
    unreadCount?: number;
};

export type ChannelSuggestionProps = {
    type: SuggestionType.Channel;
    className?: string;
    channelType: ChannelType;
    archived?: boolean;
    name: string;
    description?: string;
    onClick?: () => void;
    unreadCount?: number;
};

export type SuggestionProps = UserSuggestionProps | BotSuggestionProps | ChannelSuggestionProps;
